import React from "react";
import MuiCircularProgress from "@mui/material/CircularProgress";
import MuiButton from "@mui/material/Button";
import MuiTextField from "@mui/material/TextField";
import MuiFormHelperText from "@mui/material/FormHelperText";
import MuiFormControl from "@mui/material/FormControl";
import MuiFileOpenIcon from "@mui/icons-material/FileOpenOutlined";
import MuiClearIcon from "@mui/icons-material/Clear";
import MuiAutocomplete from "@mui/material/Autocomplete";

// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelHelperSrc from "../../model/HelperSrc";
import ControllerLocalization from "../../controller/Localization";
import ControllerInvoiceUpload from "../../controller/custom/InvoiceUpload";
import ViewLoader from "../Loader";

let isRendered = false;

const viewPageInvoiceUpload: React.FC = () => {
    // Variable
    const controllerInvoiceUpload = new ControllerInvoiceUpload(isRendered);
    const controllerLocalization = new ControllerLocalization(isRendered);

    // Method
    controllerInvoiceUpload.initializeHook();
    controllerLocalization.initializeHook();

    // Render
    isRendered = true;

    if (controllerLocalization.getStorageMain && controllerInvoiceUpload.getSelectOption && controllerInvoiceUpload.getValidationForm) {
        return (
            <div className="view_invoice_upload form" data-at_id="view_invoice_upload">
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerInvoiceUpload.getDataMain) {
                        html.push(
                            <div>
                                <div className="field_container">
                                    <MuiAutocomplete
                                        blurOnSelect
                                        options={(() => {
                                            const optionList: ModelHelperSrc.IelementOption[] = [{ value: "", display_name: "" }];

                                            for (const optionData of Object.values(controllerInvoiceUpload.getSelectOption.client_id)) {
                                                const optionDataTyped = optionData as ModelHelperSrc.IelementOption;

                                                optionList.push(optionDataTyped);
                                            }

                                            return optionList;
                                        })()}
                                        getOptionLabel={(option) => option.display_name}
                                        renderOption={(props, option) => {
                                            if (controllerLocalization.getStorageMain) {
                                                return (
                                                    <li {...props} data-at_id={`select_${option.display_name ? option.display_name : "select"}`}>
                                                        {option.display_name || controllerLocalization.getStorageMain.select}
                                                    </li>
                                                );
                                            }
                                        }}
                                        isOptionEqualToValue={(opt, val) => String(opt.value) === String(val.value)}
                                        renderInput={(params) => (
                                            <div>
                                                <MuiTextField
                                                    {...params}
                                                    variant="outlined"
                                                    className="field_value"
                                                    data-at_id="input_client_id"
                                                    required={
                                                        controllerInvoiceUpload.getValidationForm
                                                            ? controllerInvoiceUpload.getValidationForm.client_id.required
                                                            : false
                                                    }
                                                    onChange={(event) => {
                                                        HelperSrc.checkRegexSelect(event.target.name, event.target.value);
                                                    }}
                                                    label={controllerLocalization.getStorageMain ? controllerLocalization.getStorageMain.client : ""}
                                                />
                                                <input
                                                    type="hidden"
                                                    className="field_value"
                                                    name="client_id"
                                                    defaultValue={controllerInvoiceUpload.getElementClientIdValue}
                                                />
                                            </div>
                                        )}
                                        onChange={(_, option) => {
                                            if (option && controllerInvoiceUpload.setElementClientIdValue) {
                                                controllerInvoiceUpload.setElementClientIdValue(option.value as string);
                                            }
                                        }}
                                    />
                                    <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                </div>
                                <div
                                    className="field_upload"
                                    onDragOver={controllerInvoiceUpload.handleDragOver}
                                    onDragLeave={controllerInvoiceUpload.handleDragLeave}
                                    onDrop={controllerInvoiceUpload.handleDrop}
                                >
                                    <p>{controllerLocalization.getStorageMain.drag_and_drop}</p>
                                </div>
                                <div className="field_container">
                                    <MuiButton
                                        className="button_primary"
                                        data-at_id="button_upload_file"
                                        disabled={controllerInvoiceUpload.getApiLoadingList.previewFile}
                                        onClick={() => {
                                            controllerInvoiceUpload.clickUpload(".input_upload");
                                        }}
                                    >
                                        {(() => {
                                            const html: JSX.Element[] = [];

                                            if (controllerInvoiceUpload.getApiLoadingList.previewFile) {
                                                html.push(<MuiCircularProgress className="icon_progress" />);
                                            } else {
                                                html.push(<>{controllerLocalization.getStorageMain.choose_file}</>);
                                            }

                                            return html;
                                        })()}
                                    </MuiButton>
                                    {(() => {
                                        const html: JSX.Element[] = [];

                                        if (controllerInvoiceUpload.getFilenameList.file) {
                                            html.push(
                                                <MuiFileOpenIcon
                                                    data-at_id="icon_show"
                                                    className="preview_icon"
                                                    onClick={() => controllerInvoiceUpload.clickShow()}
                                                />
                                            );
                                        }

                                        return html;
                                    })()}
                                    {controllerInvoiceUpload.getFilenameList.file}
                                    <MuiFormControl className="field_container">
                                        <div className="field_value">
                                            <input
                                                className="input_upload"
                                                data-at_id="input_file"
                                                name="file"
                                                type="file"
                                                multiple={false}
                                                required={controllerInvoiceUpload.getValidationForm.file.required}
                                                onChange={(event) => {
                                                    if (controllerInvoiceUpload.getValidationForm) {
                                                        HelperSrc.checkRegex(
                                                            event.target,
                                                            event.target.value,
                                                            controllerInvoiceUpload.getValidationForm.file.regex_pattern,
                                                            controllerInvoiceUpload.getValidationForm.file.error_msg
                                                        );
                                                    }
                                                    controllerInvoiceUpload.returnFilename(event.target.files);
                                                }}
                                            />
                                        </div>
                                        <MuiFormHelperText className="field_helper"></MuiFormHelperText>
                                    </MuiFormControl>
                                </div>
                                <div className="bottom">
                                    <div className="button_container">
                                        <MuiButton
                                            className="button_primary"
                                            data-at_id="button_upload"
                                            disabled={controllerInvoiceUpload.getApiLoadingList.create}
                                            onClick={(event) => {
                                                controllerInvoiceUpload.clickSave(event);
                                            }}
                                        >
                                            {(() => {
                                                const html: JSX.Element[] = [];

                                                if (controllerInvoiceUpload.getApiLoadingList.create) {
                                                    html.push(<MuiCircularProgress className="icon_progress" />);
                                                } else {
                                                    html.push(<>{controllerLocalization.getStorageMain.upload}</>);
                                                }

                                                return html;
                                            })()}
                                        </MuiButton>
                                    </div>
                                </div>
                            </div>
                        );
                    }

                    return html;
                })()}
                {(() => {
                    const html: JSX.Element[] = [];

                    if (controllerInvoiceUpload.getApiLoadingList.previewFile !== undefined) {
                        if (controllerInvoiceUpload.getApiLoadingList.previewFile) {
                            html.push(
                                <div className="right">
                                    <MuiCircularProgress className="icon_progress_absolute" />
                                </div>
                            );
                        } else {
                            if (controllerInvoiceUpload.getUrlFile) {
                                html.push(
                                    <div className="right">
                                        <div className="content_preview">
                                            <MuiButton
                                                data-at_id="icon_close"
                                                className="button_primary"
                                                onClick={() => controllerInvoiceUpload.clickClose()}
                                            >
                                                <MuiClearIcon />
                                            </MuiButton>
                                            <embed data-at_id="pdf_preview" className="pdf_preview" src={controllerInvoiceUpload.getUrlFile} />
                                        </div>
                                    </div>
                                );
                            }
                        }
                    }

                    return html;
                })()}
            </div>
        );
    } else {
        return <ViewLoader />;
    }
};

export default viewPageInvoiceUpload;
